import s25_ultra from "../../assets/samsung/s25_ultra/s25_ultra.jpeg";
import s25_ultra_titanium_gray from "../../assets/samsung/s25_ultra/s25_ultra_titanium_gray.jpeg";
import s25_ultra_titanium_black from "../../assets/samsung/s25_ultra/s25_ultra_titanium_black.jpeg";
import s25_ultra_titanium_whitesilver from "../../assets/samsung/s25_ultra/s25_ultra_titanium_whitesilver.jpeg";
import s25_ultra_titanium_silverblue from "../../assets/samsung/s25_ultra/s25_ultra_titanium_silverblue.jpeg";
import s26_ultra1 from "../../assets/samsungStore/GalaxyS26/S26ultra/s26_ultra1.png";
import s26_ultra2 from "../../assets/samsungStore/GalaxyS26/S26ultra/s26_ultra2.png";
import s26_ultra3 from "../../assets/samsungStore/GalaxyS26/S26ultra/s26_ultra3.png";
import s26_ultra4 from "../../assets/samsungStore/GalaxyS26/S26ultra/s26_ultra4.png";
import s26_ultra5 from "../../assets/samsungStore/GalaxyS26/S26ultra/s26_ultra5.png";

import s26_1 from "../../assets/samsungStore/GalaxyS26/S26/S26/s26_1.png";
import s26_2 from "../../assets/samsungStore/GalaxyS26/S26/S26/s26_2.png";
import s26_3 from "../../assets/samsungStore/GalaxyS26/S26/S26/s26_3.png";
import s26_4 from "../../assets/samsungStore/GalaxyS26/S26/S26/s26_4.png";
import s26_5 from "../../assets/samsungStore/GalaxyS26/S26/S26/s26_5.png";

import s26_plus1 from "../../assets/samsungStore/GalaxyS26/S26Plus/s26_plus1.png";
import s26_plus2 from "../../assets/samsungStore/GalaxyS26/S26Plus/s26_plus2.png";
import s26_plus3 from "../../assets/samsungStore/GalaxyS26/S26Plus/s26_plus3.png";

import s25 from "../../assets/samsung/s25/s25.jpeg";
import s25_icyblue from "../../assets/samsung/s25/s25_icyblue.jpeg";
import s25_mint from "../../assets/samsung/s25/s25_mint.jpeg";
import s25_silver_shadow from "../../assets/samsung/s25/s25_silver_shadow.jpeg";
import s25_navy from "../../assets/samsung/s25/s25_navy.jpeg";

import s25_edge from "../../assets/samsung/mix/s25_edge.jpeg";
import s25_edge_titanium_jetblack from "../../assets/samsung/mix/s25_edge_titanium_jetblack.jpeg";
import s25_edge_titanium_silver from "../../assets/samsung/mix/s25_edge_titanium_silver.jpeg";

import s25_plus from "../../assets/samsung/mix/s25_plus.jpeg";
import s25_plus_navy from "../../assets/samsung/mix/s25_plus_navy.jpeg";
import s25_plus_silver_shadow from "../../assets/samsung/mix/s25_plus_silver_shadow.jpeg";

export const galaxySSeries = [
  {
    id: 5,
    title: "Galaxy S26 Ultra (12/256 GB)",
    productImage: s26_ultra1,
    images: [s26_ultra1, s26_ultra2, s26_ultra3, s26_ultra4, s26_ultra5],
    discountedPrice: "1,39,900",
    colors: [
      "Sky Blue",
      "White",
      "Cobalt Violet",
      "Black",
    ],
    offers: [
      { label: "Offer", value: "(Inclusive of credit card offers)" },
      { label: "EMI", value: "No Cost EMI at Rs. 5,834 p.m." },
    ],
    specifications: {
      Specs: [
        "Variant: 12GB RAM / 256GB storage",
        '6.9" QHD+ Dynamic AMOLED 2X display, adaptive refresh rate up to 120Hz',
        "Snapdragon 8 Elite for Galaxy",
        "12GB RAM with high-speed storage options",
        "Pro camera system with 200MP wide camera and advanced zoom",
        "5000mAh battery with fast wired and wireless charging",
        "Galaxy AI features for photos, productivity and communication",
        "IP68 water and dust resistance",
      ],
    },
  },
  {
    id: 6,
    title: "Galaxy S26 Ultra (12/512 GB)",
    productImage: s26_ultra1,
    images: [s26_ultra1, s26_ultra2, s26_ultra3, s26_ultra4, s26_ultra5],
    discountedPrice: "1,59,900",
    colors: [
      "Sky Blue",
      "White",
      "Cobalt Violet",
      "Black",
    ],
    offers: [
      { label: "Offer", value: "(Inclusive of credit card offers)" },
      { label: "EMI", value: "No Cost EMI at Rs. 5,834 p.m." },
    ],
    specifications: {
      Specs: [
        "Variant: 12GB RAM / 512GB storage",
        '6.9" QHD+ Dynamic AMOLED 2X display, adaptive refresh rate up to 120Hz',
        "Snapdragon 8 Elite for Galaxy",
        "12GB RAM with high-speed storage options",
        "Pro camera system with 200MP wide camera and advanced zoom",
        "5000mAh battery with fast wired and wireless charging",
        "Galaxy AI features for photos, productivity and communication",
        "IP68 water and dust resistance",
      ],
    },
  },
  {
    id: 7,
    title: "Galaxy S26 Plus (12/256 GB)",
    productImage: s26_plus1,
    images: [s26_plus1, s26_plus2, s26_plus3],
    discountedPrice: "1,19,999",
    colors: [
      "Cobalt Violet",
      "Black",
    ],
    offers: [
      { label: "Offer", value: "(Inclusive of credit card offers)" },
      { label: "EMI", value: "No Cost EMI at Rs. 5,000 p.m." },
    ],
    specifications: {
      Specs: [
        "Variant: 12GB RAM / 256GB storage",
        '6.65" FHD+ Dynamic AMOLED 2X display, adaptive refresh rate up to 120Hz',
        "Snapdragon 8 Elite Gen 5 for Galaxy",
        "12GB RAM with high-speed storage options",
        "Pro camera system with 50MP wide camera and advanced zoom",
        "5000mAh battery with fast wired and wireless charging",
        "Galaxy AI features for photos, productivity and communication",
        "IP68 water and dust resistance",
      ],
    },
  },
  {
    id: 3,
    title: "Galaxy S26 (12/256 GB)",
    productImage: s26_1,
    images: [s26_1, s26_2, s26_3, s26_4, s26_5],
    discountedPrice: "87,999",
    colors: [
      "Sky Blue",
      "White",
      "Cobalt Violet",
      "Black",
    ],
    offers: [
      { label: "Offer", value: "(Inclusive of credit card offers)" },
      { label: "EMI", value: "No Cost EMI at Rs. 3,667 p.m." },
    ],
    specifications: {
      Specs: [
        "Variant: 12GB RAM / 256GB storage",
        '6.7" FHD+ Dynamic AMOLED 2X display, adaptive refresh rate up to 120Hz',
        "Snapdragon 8 Gen 3 for Galaxy",
        "12GB RAM with high-speed storage options",
        "Pro camera system with 50MP wide camera and advanced zoom",
        "5000mAh battery with fast wired and wireless charging",
        "Galaxy AI features for photos, productivity and communication",
        "IP68 water and dust resistance",
      ],
    },
  },
  {
    id: 4,
    title: "Galaxy S26 (12/512 GB)",
    productImage: s26_1,
    images: [s26_1, s26_2, s26_3, s26_4, s26_5],
    discountedPrice: "1,07,900",
    colors: [
      "Sky Blue",
      "White",
      "Cobalt Violet",
      "Black",
    ],
    offers: [
      { label: "Offer", value: "(Inclusive of credit card offers)" },
      { label: "EMI", value: "No Cost EMI at Rs. 4,496 p.m." },
    ],
    specifications: {
      Specs: [
        "Variant: 12GB RAM / 512GB storage",
        '6.7" FHD+ Dynamic AMOLED 2X display, adaptive refresh rate up to 120Hz',
        "Snapdragon 8 Gen 3 for Galaxy",
        "12GB RAM with high-speed storage options",
        "Pro camera system with 50MP wide camera and advanced zoom",
        "5000mAh battery with fast wired and wireless charging",
        "Galaxy AI features for photos, productivity and communication",
        "IP68 water and dust resistance",
      ],
    },
  },
  {
    id: 1,
    title: "Galaxy S25 Ultra",
    productImage: s25_ultra,
    images: [
      s25_ultra,
      s25_ultra_titanium_gray,
      s25_ultra_titanium_black,
      s25_ultra_titanium_whitesilver,
      s25_ultra_titanium_silverblue,
    ],
    // originalPrice: '₹ 13,999',
    discountedPrice: "1,29,999",
    // offerText: 'Flat ₹3,901 off',
    colors: [
      "Titanium Silverblue",
      "Titanium Gray",
      "Titanium Black",
      "Titanium Whitesilver",
    ],
    offers: [
      // { label: 'Offer', value: 'Get ₹1500 off on Axis Bank Credit Card' },
      // { label: 'EMI', value: 'Available from ₹999/month' },
    ],
    specifications: {
      // Audio: 'Dolby Atmos',
      // Battery: '5000mAh with 25W fast charging',
      // Controls: 'On-screen fingerprint scanner',
      // Compatibility: 'Works with Android 13',
      // Specs: {
      //   Chip: 'Exynos 1380',
      //   Connectivity: '5G, Wi-Fi 5',
      //   Case: 'Supports wireless charging',
      //   Weight: '202g',
      //   WaterResistance: 'IP67',
      //   Warranty: '1 year',
      // },
      Specs: [
        '6.8"inch - 3120 X 1220 (quad HD+). Refresh rate max. 120Hz',
        "Snapdragon 8 Elite",
        "Comes with S pen",
        "Up to 12GB RAM & Up to 1TB Storage",
        "Rear camera - Resolution (Multiple) - 200MP + 50MP + 50MP + 10MP",
        "Front Camera - 12MP",
        "5000mah (up to 31hrs video playback time)",
        "Video playing resolution - UHD 8K(7680 X 4320)@60fps",
        "IP68 Water Resistance.",
      ],
    },
  },

  {
    id: 2,
    title: "Galaxy S25",
    productImage: s25,
    images: [s25, s25_icyblue, s25_mint, s25_silver_shadow, s25_navy],
    // originalPrice: '₹ 13,999',
    discountedPrice: "80,999",
    // offerText: 'Flat ₹3,901 off',
    colors: ["Silver Shadow", "Navy", "Iceblue", "Mint"],
    offers: [
      // { label: 'Offer', value: 'Get ₹1500 off on Axis Bank Credit Card' },
      // { label: 'EMI', value: 'Available from ₹999/month' },
    ],
    specifications: {
      // Audio: 'Dolby Atmos',
      // Battery: '5000mAh with 25W fast charging',
      // Controls: 'On-screen fingerprint scanner',
      // Compatibility: 'Works with Android 13',
      // Specs: {
      //   Chip: 'Exynos 1380',
      //   Connectivity: '5G, Wi-Fi 5',
      //   Case: 'Supports wireless charging',
      //   Weight: '202g',
      //   WaterResistance: 'IP67',
      //   Warranty: '1 year',
      // },
      Specs: [
        '6.1"inch - 2340 x 1080 FHD+ Dynamic AMOLED 2X',
        "Adaptive Refresh Rate up to 120 Hz",
        "Snapdragon 8 Elite",
        "Up to 12GB RAM & Up to 512GB Storage",
        "Triple Rear camera - 50 MP(Wide-angle Camera) + 12 MP(Ultra Wide Camera) + 10 MP(Telephoto)",
        "Front Camera - 12MP",
        "4000mah (up to 29hrs video playback time)",
        "Video playing resolution - UHD 8K(7680 X 4320)@60fps",
        "IP68 Water Resistance.",
      ],
    },
  },

  {
    id: 3,
    title: "Galaxy S25 Edge",
    productImage: s25_edge,
    images: [s25_edge, s25_edge_titanium_jetblack, s25_edge_titanium_silver],
    // originalPrice: '₹ 13,999',
    discountedPrice: "1,09,999",
    // offerText: 'Flat ₹3,901 off',
    colors: ["Titanium Silver", "Titanium Jetblack"],
    offers: [
      // { label: 'Offer', value: 'Get ₹1500 off on Axis Bank Credit Card' },
      // { label: 'EMI', value: 'Available from ₹999/month' },
    ],
    specifications: {
      // Audio: 'Dolby Atmos',
      // Battery: '5000mAh with 25W fast charging',
      // Controls: 'On-screen fingerprint scanner',
      // Compatibility: 'Works with Android 13',
      // Specs: {
      //   Chip: 'Exynos 1380',
      //   Connectivity: '5G, Wi-Fi 5',
      //   Case: 'Supports wireless charging',
      //   Weight: '202g',
      //   WaterResistance: 'IP67',
      //   Warranty: '1 year',
      // },
      Specs: [
        '6.6"inch - 3120 x 1440QHD+ Dynamic AMOLED 2X',
        "Adaptive Refresh Rate up to 120 Hz",
        "Snapdragon 8 Elite",
        "Up to 12GB RAM & Up to 512GB Storage",
        "Dual Rear camera - 200 MP(Wide-angle Camera) + 12 MP(Ultra Wide Camera)",
        "Front Camera - 12MP",
        "3900mah (up to 24hrs video playback time)",
        "Video playing resolution - UHD 8K(7680 X 4320)@60fps",
        "IP68 Water Resistance.",
      ],
    },
  },

  {
    id: 4,
    title: "Galaxy S25 Plus",
    productImage: s25_plus,
    images: [s25_plus, s25_plus_navy, s25_plus_silver_shadow],
    // originalPrice: '₹ 13,999',
    discountedPrice: "99,999",
    // offerText: 'Flat ₹3,901 off',
    colors: ["Silver Shadow", "Navy", "Mint"],
    offers: [
      // { label: 'Offer', value: 'Get ₹1500 off on Axis Bank Credit Card' },
      // { label: 'EMI', value: 'Available from ₹999/month' },
    ],
    specifications: {
      // Audio: 'Dolby Atmos',
      // Battery: '5000mAh with 25W fast charging',
      // Controls: 'On-screen fingerprint scanner',
      // Compatibility: 'Works with Android 13',
      // Specs: {
      //   Chip: 'Exynos 1380',
      //   Connectivity: '5G, Wi-Fi 5',
      //   Case: 'Supports wireless charging',
      //   Weight: '202g',
      //   WaterResistance: 'IP67',
      //   Warranty: '1 year',
      // },
      Specs: [
        '6.6"inch - 3120 X 1440 (Quad HD+) + Dynamic AMOLED 2X',
        "Adaptive Refresh Rate up to 120 Hz",
        "Snapdragon 8 Elite",
        "Up to 12GB RAM & Up to 512GB Storage",
        "Triple Rear camera - 50 MP(Wide-angle Camera) + 12 MP(Ultra Wide Camera) + 10 MP(Telephoto)",
        "Front Camera - 12MP",
        "4900mah (up to 30hrs video playback time)",
        "Video recording resolution - UHD 8K(7680 X 4320)@60fps",
        "IP68 Water Resistance",
      ],
    },
  },
];
